function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.25.25c-.589 0-1.19.207-1.617.633C3.207 1.309 3 1.91 3 2.5v1.125c0 .448.246.853.492 1.23-.048.07-.127.102-.176.176-.43.655-.86 1.472-1.23 2.356C1.348 9.149.75 11.057.75 12.52v6.855a3.393 3.393 0 003.375 3.375h6.75a3.393 3.393 0 003.375-3.375V12.52c0-1.464-.598-3.371-1.336-5.133-.37-.884-.8-1.701-1.23-2.356-.049-.074-.128-.105-.176-.176.246-.377.492-.782.492-1.23V2.5c0-.589-.207-1.19-.633-1.617C10.941.457 10.34.25 9.75.25h-4.5zm0 2.25h4.5v1.125h-4.5V2.5zm.246 3.375h4.008c.079.083.189.224.316.422.308.466.65 1.178.985 1.969C11.473 9.852 12 11.847 12 12.52v6.855c0 .624-.501 1.125-1.125 1.125h-6.75A1.122 1.122 0 013 19.375V12.52c0-.673.527-2.668 1.195-4.254.334-.791.677-1.503.985-1.97.127-.197.237-.338.316-.421z",
  fill: "#BCC9CE"
});

function SvgMilk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 23",
    fill: "none"
  }, props), _ref);
}

export default SvgMilk;